export const STORAGE_KEY_APP_NAME = "Lost In Translation"
export const STORAGE_KEY_USER = "user"